import React from "react";
import * as Icon from "react-feather";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import Avatar from "../../../components/@vuexy/avatar/avatarComponent";
// Campanita de notificaciones oculta a pedido: la funcionalidad no esta en uso.
// Se deja el import comentado (y el componente en el repo) para poder volver a
// mostrarla sin rehacer nada.
// import NavbarNotifications from "./navbarNotifications";

const MOCK_USER = {
  denominacion: "Bianca Cano",
  rol: "Administrador",
  avatarColor: "primary",
};

const UserDropdown = ({ user }) => {
  const navigate = useNavigate();

  const goToLogout = () => navigate("/logOut");
  const goToProfile = () => navigate("/perfil");

  return (
    <DropdownMenu end className="dropdown-menu-media mt-0 custom-user-dropdown">
      <div className="dropdown-menu-header">
        <div className="user-dropdown-header">
          <Avatar
            color={user.avatarColor}
            content={user.denominacion
              .split(" ")
              .map((n) => n[0])
              .join("")}
          />
          <div className="user-dropdown-info">
            <h6>{user.denominacion}</h6>
            <small>{user.rol}</small>
          </div>
        </div>
      </div>

      <DropdownItem onClick={goToProfile}>
        <Icon.User size={14} className="mr-1" />
        Perfil
      </DropdownItem>

      <DropdownItem onClick={goToLogout}>
        <Icon.LogOut size={14} className="mr-1" />
        Cerrar sesión
      </DropdownItem>
    </DropdownMenu>
  );
};

const NavbarCustom = ({ denominacion }) => {
  const navigate = useNavigate();

  const user = denominacion
    ? {
        denominacion,
        rol: "Usuario",
        avatarColor: "primary",
      }
    : MOCK_USER;

  const goToProfile = (e) => {
    e.stopPropagation();
    navigate("/perfil");
  };

  return (
    <ul className="nav navbar-nav navbar-nav-user float-right d-flex align-items-center">
      {/* <NavbarNotifications /> */}

      <UncontrolledDropdown
        tag="li"
        className="dropdown-user nav-item"
        direction="down"
      >
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div
            className="user-nav d-sm-flex d-none"
            style={{ cursor: "pointer" }}
            onClick={goToProfile}
          >
            <span className="text-bold-600">{user.denominacion}</span>
          </div>

          <span style={{ cursor: "pointer" }} onClick={goToProfile}>
            <Avatar
              color={user.avatarColor}
              content={user.denominacion
                .split(" ")
                .map((n) => n[0])
                .join("")}
            />
          </span>
        </DropdownToggle>

        <UserDropdown user={user} />
      </UncontrolledDropdown>
    </ul>
  );
};

const mapStateToProps = (state) => ({
  denominacion: state?.sso?.userProfile?.denominacion || null,
});

export default connect(mapStateToProps)(NavbarCustom);
